import { FormEvent, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineTextInElementId, defineValueInInput } from "../../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../../components/funcRemoveAllErros";
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../../../config/apiClient";
import { getCookie } from "../../../../../config/cookies";
import styles from '../../../../colaborador/styles/colaborador.module.css'

export default function ModalImportarPDF({ show, handleClose, handleUpdate }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [empresas, setEmpresas] = useState<any[]>([]);
    const [arquivosDados, setArquivosDados] = useState<any[]>([]);
    const [variosRegistros, setVariosRegistros] = useState<boolean>(false);
    const [variosRegistrosStatus, setVariosRegistrosStatus] = useState<boolean>(false);

    useEffect(() => {
        const getDados = async () => {
            setLoading(true);
            const api = await reqGetNew(ApiEndpoints.nfEmpresasInfosNFSe);
            if (api.status === 200) {
                setEmpresas(api.data);
                console.log(api.data);
            }
            setLoading(false);
        };
        getDados();
    }, []);

    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();

        removeAllErrorMsg();

        const form: any = event.target;
        if (variosRegistros) { handleSubmitArquivos(form) }
        if (!variosRegistros) { handleSubmitArquivo(form) }
    }
    function handleSubmitArquivo(form:any) { 
        let formValidado = true;

        let dadosImportar = {
            pdf: form.pdf.files,
            id_empresa: Number(form.id_empresa.value),
            chave: String(form.chave.value),
        };
        console.log(dadosImportar);

        if (dadosImportar.id_empresa === 0) {
            form.id_empresa.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        if (dadosImportar.chave === "") {
            form.chave.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        if (dadosImportar.pdf.length === 0) {
            form.pdf.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        if (!formValidado) {
            return;
        }

        importarArquivo(dadosImportar);
    }
    function handleSubmitArquivos(form:any) { 
        let formValidado = true;
        let arquivos:any[] = form.pdfs.files
        let dadosImportar:any = {
            pdfs: [],
            id_empresa: Number(form.id_empresa.value),
        };

        if (dadosImportar.id_empresa === 0) {
            form.id_empresa.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (arquivos.length === 0) {
            form.pdfs.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        let chaves:string[] = []
        let arquivos_aux:any[] = []
        for (let arquivo of arquivos) {
            arquivos_aux.push(arquivo)
            let arquivo_nome_original = String(arquivo.name)
            let chave_nfs = String(arquivo.name)
            chave_nfs = chave_nfs.replaceAll(".pdf", "").replaceAll("NFS", "")
            if (chave_nfs.length !== 50) { 
                formValidado = false
                toast.warning(`Remover o Arquivo Inválido: ${arquivo_nome_original}`, {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
                break
            }
            chaves.push(chave_nfs)
            dadosImportar.pdfs.push({
                chave: chave_nfs,
                arquivo: arquivo_nome_original,
            })
        }
        
        console.log(dadosImportar)
        console.log(arquivos)
        console.log(arquivos_aux)
        if (!formValidado) {
            return;
        }

        importarArquivos(dadosImportar, chaves, arquivos_aux);
    }

    async function importarArquivos(dadosImportar:any, chaves:string[], arquivos:any[]) { 
        setLoading(true)
        const dadosChaves = {
            id_empresa: dadosImportar.id_empresa,
            chaves: chaves,
        }

        // Validar se todos os PDF são da mesma empresa
        const api = await reqPostNew(ApiEndpoints.nfseValidarPDFs, dadosChaves)
        if (api.status !== 200) { 
            setLoading(false)
            return
        }
        setVariosRegistrosStatus(true)

        // Enviar arquivos para serem importados
        let qtd_pdf_importados = 0
        let qtd_pdf_enviados = 0
        let pdf_nao_importados = ""
        for (let pdf of dadosImportar.pdfs) {
            let arquivo = arquivos.filter((reg: any) => reg.name === pdf.arquivo)
            if (arquivo.length === 0) { continue }
            let dadosNota = {
                id_empresa: dadosImportar.id_empresa,
                chave: pdf.chave,
                pdf: arquivo[0],
            }
            qtd_pdf_enviados++
            defineTextInElementId("status_importacao", `Enviando ${qtd_pdf_enviados}/${chaves.length}`)
            let api = await enviarPDF(dadosNota)
            let api_erro = ""
            if (api.status === 200) { 
                qtd_pdf_importados++
            } else {
                pdf_nao_importados += pdf_nao_importados === "" ? pdf.chave : `, ${pdf.chave}`
            }
            
            if (api.status !== 200 && api.status !== 0) { 
                api_erro = `Erro: ${api.message}`
            }
            let arquivos_dados_aux = []
            for (let pdf_aux of arquivosDados) { 
                if (pdf_aux.nome === pdf.arquivo) { 
                    pdf_aux.status = api.status
                    if (api_erro !== "") { 
                        pdf_aux.erro = api_erro
                    }
                }
                arquivos_dados_aux.push(pdf_aux)
            }
            setArquivosDados(arquivos_dados_aux)
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        if (qtd_pdf_importados === chaves.length) { 
            toast.success("Todos PDF importados com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            setVariosRegistrosStatus(false)
        }
        if (qtd_pdf_importados !== chaves.length) { 
            toast.success(`PDFs que não foram importados: ${pdf_nao_importados}!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
                autoClose: 5000,
            });
        }
        defineValueInInput("pdfs", "");
        defineValueInInput("id_empresa", "0");
        handleUpdate();
        setLoading(false)
    }
    async function enviarPDF(dadosImportar: any):Promise<any> {
        const token = getCookie("token");
        const id_usuario = getCookie("id_user");
        let dados = new FormData();
        dados.append("pdf", dadosImportar.pdf);
        dados.append("id_empresa", dadosImportar.id_empresa);
        dados.append("chave", dadosImportar.chave);
        try {
            let api: Response;
            let apiData = await fetch(ApiEndpoints.nfseImportarPDF.endpoint, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    id_usuario: id_usuario,
                },
                body: dados,
            }).then((response) => {
                api = response;
                return response.json();
            });
            if (api!.status === 200) {
                return {
                    status: api!.status,
                    message: String(apiData.message),
                }
            } else {
                return {
                    status: api!.status,
                    message: String(apiData.message),
                }
            }
        } catch (error) {
            console.log(error);
            return {
                status: 0,
                message: "Não foi possível importar, verifique se o layout está correto ou contate o suporte!",
            }
        }
    }
    async function importarArquivo(dadosImportar: any) {
        setLoading(true);

        const dadosChaves = {
            id_empresa: dadosImportar.id_empresa,
            chaves: [dadosImportar.chave],
        }
        // Validar se todos os PDF são da mesma empresa
        const api = await reqPostNew(ApiEndpoints.nfseValidarPDFs, dadosChaves)
        if (api.status !== 200) { 
            setLoading(false)
            return
        }

        const token = getCookie("token");
        const id_usuario = getCookie("id_user");
        let dados = new FormData();
        dados.append("pdf", dadosImportar.pdf[0]);
        dados.append("id_empresa", dadosImportar.id_empresa);
        dados.append("chave", dadosImportar.chave);

        try {
            let api: Response;
            let apiData = await fetch(ApiEndpoints.nfseImportarPDF.endpoint, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    id_usuario: id_usuario,
                },
                body: dados,
            }).then((response) => {
                api = response;
                return response.json();
            });
            if (api!.status === 200) {
                toast.success("PDF importado com sucesso!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
                defineValueInInput("pdf", "");
                defineValueInInput("id_empresa", "0");
                defineValueInInput("chave", "");
                handleUpdate();
            } else {
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
            }
        } catch (error) {
            console.log(error);
            toast.warn("Não foi possível importar, verifique se o layout está correto ou contate o suporte!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }

        setLoading(false);
    }

    function handleChangeArquivo(event: any) {
        let arquivos: any[] = event.target.files;
        if (arquivos.length > 0) {
            let arquivo = arquivos[0];
            let filename = String(arquivo.name).replaceAll(".pdf", "");
            defineValueInInput("chave", filename);
        }
    }
    function handleChangeArquivos(event: any) {
        const arquivos: any[] = event.target.files
        let arquivos_aux: any[] = []
        for (let pdf of arquivos) { 
            arquivos_aux.push({
                status: 0,
                nome: pdf.name,
                erro: "",
            })
        }
        setArquivosDados(arquivos_aux)
    }
    function handleChangeModoEnvio(event:any) { 
        const input = event.target
        const varios_registros = input.checked
        if (!varios_registros) { 
            setArquivosDados([])
        }
        setVariosRegistros(varios_registros)
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Importar PDF</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formImportarPdf`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Empresa:</Form.Label>
                                <Form.Select name="id_empresa" id="id_empresa" aria-label="Selecione o opção">
                                    <option value="0">Não Selecionado</option>
                                    {empresas.map((dados, idx, arr) => {
                                        return (
                                            <option value={dados.empresa.id_empresa} key={idx}>
                                                {dados.empresa.nome}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">Informe a Empresa!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        {variosRegistros && <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Selecione os Arquivos PDF:</Form.Label>
                                <Form.Control type="file" multiple={true} name="pdfs" id="pdfs" aria-label="Selecione os PDFs" accept=".pdf" onChange={handleChangeArquivos} />
                                <Form.Control.Feedback type="invalid">Selecione os arquivos!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>}
                        {!variosRegistros && <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Selecione o Arquivo PDF:</Form.Label>
                                <Form.Control type="file" name="pdf" id="pdf" aria-label="Selecione o PDF" accept=".pdf" onChange={handleChangeArquivo} />
                                <Form.Control.Feedback type="invalid">Selecione o arquivo!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>}
                    </Row>
                    {!variosRegistros &&
                        <div>
                            <br></br>
                            <Row>
                                <Col className="col-12">
                                    <Form.Group>
                                        <Form.Label>Chave NFS:</Form.Label>
                                        <Form.Control type="text" name="chave" id="chave" autoComplete="off" />
                                        <Form.Control.Feedback type="invalid">Informe uma chave válida!</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>
                    }
                    <br></br>
                    <Row>
                        <Col className="col-12">
                            <Form.Check
                                type="switch"
                                id="varios_registros"
                                label="Importar vários registros"
                                className={styles.inputCheck}
                                checked={variosRegistros}
                                onChange={handleChangeModoEnvio}
                            />
                        </Col>
                    </Row>
                    <br />
                    <div style={{display: variosRegistros && variosRegistrosStatus ? "block" : "none"}}>
                        <p id="status_importacao"></p>
                        <br></br>
                    </div>
                    
                    <div id="arquivos_dados_status" style={{display: variosRegistros ? "block" : "none"}}>
                        {arquivosDados.map((pdf, idx, arr) => { 
                            let icone = <span className="material-symbols-outlined" style={{marginRight: "10px"}}>
                                schedule_send
                            </span>
                            if (pdf.status > 0) { 
                                icone = <span className="material-symbols-outlined" style={{color: "red", marginRight: "10px"}}>
                                    cloud_alert
                                </span>
                            }
                            if (pdf.status === 200) { 
                                icone = <span className="material-symbols-outlined" style={{color: "green", marginRight: "10px"}}>
                                    cloud_done
                                </span>
                            }
                            return (
                                <div>
                                    <div className="div-row">
                                        {icone}
                                        <p>{pdf.nome}</p>
                                    </div>
                                    {pdf.status > 0 && pdf.status !== 200 && <p>{pdf.erro}</p>}
                                    <br></br>
                                </div>
                            )
                        })}
                    </div>
                    <Button type="submit" disabled={loading} style={{ marginRight: "10px" }}>
                        {loading ? "Aguarde..." : "Importar"}
                    </Button>
                </Form>
                <br></br>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

interface iProps {
    show: boolean;
    handleClose: any;
    handleUpdate: any;
}
